import { render } from "./Widget4.vue?vue&type=template&id=160224a8"
import script from "./Widget4.vue?vue&type=script&lang=ts"
export * from "./Widget4.vue?vue&type=script&lang=ts"
script.render = render

export default script